export const startDateState = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日',
}

export const FREQUENCY_MAP = {
  DAY: 1,
  WEEK: 2,
}

export const frequencyState = {
  [FREQUENCY_MAP.DAY]: '日扣',
  [FREQUENCY_MAP.WEEK]: '周扣',
}

export const PERIOD_LIMIT_MAP = {
  NO_LIMIT: 0,
  LIMIT: 1,
}

export const periodLimitState = {
  [PERIOD_LIMIT_MAP.NO_LIMIT]: '不限额',
  [PERIOD_LIMIT_MAP.LIMIT]: '周期内限额',
}

// 是否需要签署租赁合同
export const IS_RENT = {
  SIGN: 1, // 是
  NOT_SIGN: 0, // 否
}
